import {
    dotWrapper, nameAvatarWrapper,
} from 'components/Table/styles/CellComponents'

import LetterAvatar from 'components/Avatar/LetterAvatar'
import React from 'react'
import {datetime} from 'utils/datetime'
import {styled} from 'stitches/config'

const StyledNameAvatarWrapper = styled('div', nameAvatarWrapper)
const StyledDotWrapper = styled('div', dotWrapper)
const StyledTime = styled('time', {whiteSpace: 'nowrap'})

export const NameAvatarCell = ({name}: {name: string}) => <StyledNameAvatarWrapper><LetterAvatar name={name} />{name}</StyledNameAvatarWrapper>


export enum DotCellStates {
  disabled = 'disabled',
  positive = 'positive',
  neutral = 'neutral',
  negative = 'negative',
  half = 'half',
}

export const DotCell = ({state}: {state: DotCellStates}) => <StyledDotWrapper state={state} />

export const TimeCell = ({time}: {time: number}) => <StyledTime dateTime={datetime(time)}>{datetime(time)}</StyledTime>
